import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CommonSandbox {
    public sidebarToggle$ = new Subject<any>();
}
